<template>
  <div id="app" @click.stop="handleClick">
    <router-view />
    <AccountModal ref="accountModal"></AccountModal>
    <ChkPwdModal ref="chkPwdModal"></ChkPwdModal>
    <UserSettingModal ref="userSettingModal"></UserSettingModal>
    <UserProfileModal ref="userProfileModal"></UserProfileModal>
    <PrivacyTermsModal></PrivacyTermsModal>
    <div class="gmask" v-show="isShowMask" @click="clickMask"></div>
    <KJ></KJ>
  </div>
</template>

<script>
import Vue from 'vue'
import Velocity from 'velocity-animate'
// eslint-disable-next-line
import VelocityUI from 'velocity-animate/velocity.ui'
import QuickSearch from './components/layout/QuickSearch'
import AccountModal from './components/account/Modal'
import ChkPwdModal from './components/account/ChangePassword'
import PrivacyTermsModal from './components/account/PrivacyTerms'
import UserSettingModal from './components/account/Setting'
import UserProfileModal from './components/account/Profile'
import KJ from '@/components/layout/KJ'
import { createNamespacedHelpers } from 'vuex'
const { mapMutations: mapAccountMutations } = createNamespacedHelpers('account')
const { mapMutations: mapDataMutations } = createNamespacedHelpers('data')
const { mapMutations: mapSearchMutations } = createNamespacedHelpers('search')

export default {
  name: 'App',
  components: { QuickSearch, AccountModal, ChkPwdModal, PrivacyTermsModal, UserSettingModal, UserProfileModal, KJ },
  data () {
    return {
      $isIE: Vue._customVars.isIE,
      isShowMask: false,
      isShowQuickSearch: false
    }
  },
  created () {
    let _vm = this
    this.$api.getDictData({
      success (response) {
        if (response.data.code === 200) {
          _vm.setRelevantPolicy(response.data.data.laws)
          _vm.setRelatedNews(response.data.data.news)
          _vm.setCategory(response.data.data.category)
          _vm.setLinks(response.data.data.links)
          _vm.setApiValue(response.data.data.api)
        }
      }
    })
    this.$api.getSearchDictData({
      success (response) {
        if (response.data.code === 200) {
          _vm.setExporter(response.data.data.exporter)
          _vm.setImporter(response.data.data.importer)
          // _vm.setProducts(response.data.data.hsTree)
        }
      }
    })
    this.loadUserInfo()
    this.loadSetting()
    this.loadHistory()
  },
  mounted () {
    this.$nextTick(() => {
      window.addEventListener('scroll', this.handleScroll, true)
      this.$root.$on('setAppMask', (event, val) => {
        this.isShowMask = val
      })
    })
  },
  methods: {
    ...mapDataMutations([
      'setExporter',
      'setImporter',
      'setProducts',
      'setRelevantPolicy',
      'setRelatedNews',
      'setCategory',
      'setLinks',
      'setApiValue'
    ]),
    ...mapSearchMutations([
      'loadHistory'
    ]),
    ...mapAccountMutations([
      'loadUserInfo',
      'loadSetting'
    ]),
    clickMask (event) {
      this.$Message.destroy()
      this.isShowMask = false
    },
    handleClick (event) {
      this.$root.$emit('appClicker', event)
    },
    handleScroll (event) {
      let scrollBorderDom = document.querySelector('.scroll-border-dom')
      if (scrollBorderDom) {
        let scrollBorderDomBottom = this._h.getOffset(scrollBorderDom).bottom
        if (scrollBorderDomBottom < -10) {
          if (!this.isShowQuickSearch) {
            this.$root.$emit('QuickShowEvent', event)
          }
          if (this.$data.$isIE) {
            setTimeout(() => {
              this.isShowQuickSearch = true
            }, 500)
          } else {
            this.isShowQuickSearch = true
          }
        } else {
          if (this.$data.$isIE) {
            setTimeout(() => {
              this.isShowQuickSearch = false
            }, 500)
          } else {
            this.isShowQuickSearch = false
          }
        }
      } else {
        this.isShowQuickSearch = false
      }
    },
    enter (el, done) {
      Velocity(el, 'transition.shrinkIn', { duration: 250, complete: done })
    },
    leave (el, done) {
      Velocity(el, 'transition.shrinkOut', { duration: 350, complete: done })
    }
  }
}
</script>
<style>
  @import "./assets/css/main.css";
  @import "./assets/css/vegas.css";
  #app{
    min-width: var(--pageMinWidth);
    user-select: none;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue